(() => {
  const setGalleryImage = (root, requestedIndex) => {
    const thumbnails = [...root.querySelectorAll('[data-mmy-image]')];
    if (!thumbnails.length) return;
    const index = (requestedIndex + thumbnails.length) % thumbnails.length;
    const thumbnail = thumbnails[index];
    const image = root.querySelector('.mmy-main-image');
    image.removeAttribute('srcset');
    image.src = thumbnail.dataset.mmyImage;
    image.alt = thumbnail.dataset.mmyAlt;
    thumbnails.forEach((button, buttonIndex) => button.setAttribute('aria-pressed', String(buttonIndex === index)));
    root.querySelector('[data-mmy-gallery-current]')?.replaceChildren(String(index + 1));
    thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    root.dataset.mmyGalleryIndex = String(index);
  };

  const filterJarWidths = (root, width) => {
    const select = root.querySelector('[data-mmy-variant]');
    if (!select) return;
    const options = [...select.options];
    options.forEach((option) => {
      const matches = option.dataset.mmyOptionWidth === width;
      option.hidden = !matches;
      option.disabled = !matches;
    });
    root.querySelectorAll('[data-mmy-variant-choice]').forEach((button) => {
      const matches = button.dataset.mmyOptionWidth === width;
      button.hidden = !matches;
      button.disabled = !matches;
    });
    const firstMatch = options.find((option) => !option.disabled);
    if (firstMatch && select.selectedOptions[0]?.disabled) {
      select.value = firstMatch.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    root.querySelectorAll('[data-mmy-width]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.mmyWidth === width)));
  };

  const init = (scope = document) => {
    const pickers = [...scope.querySelectorAll('[data-mmy-picker]')];
    if (scope.matches?.('[data-mmy-picker]')) pickers.push(scope);
    pickers.forEach((root) => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      root.querySelector('[data-mmy-mobile-choice]')?.addEventListener('change', (event) => {
        root.querySelector(`[data-mmy-choice="${event.target.value}"]`)?.click();
      });
      root.addEventListener('click', (event) => {
        const mobileChoice = event.target.closest('[data-mmy-mobile-choice-button]');
        if (mobileChoice) {
          const choiceIndex = mobileChoice.dataset.mmyChoiceIndex;
          root.querySelector('[data-mmy-cup-label]').textContent = mobileChoice.textContent.trim();
          root.querySelectorAll('[data-mmy-mobile-choice-button]').forEach((item) => item.setAttribute('aria-selected', String(item === mobileChoice)));
          root.querySelector('[data-mmy-cup-picker]').open = false;
          root.querySelector(`[data-mmy-choice="${choiceIndex}"]`)?.click();
          return;
        }
        const button = event.target.closest('[data-mmy-choice]');
        if (!button) return;
        root.querySelectorAll('[data-mmy-choice]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        root.querySelectorAll('[data-mmy-panel]').forEach((panel) => { panel.hidden = panel.dataset.mmyPanel !== button.dataset.mmyChoice; });
        if (window.matchMedia('(max-width: 649px)').matches) {
          const panel = root.querySelector(`[data-mmy-panel="${button.dataset.mmyChoice}"]`);
          window.setTimeout(() => panel?.querySelector('.mmy-picker-image')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 60);
        }
      });
    });
    const products = [...scope.querySelectorAll('[data-mmy-product]')];
    if (scope.matches?.('[data-mmy-product]')) products.push(scope);
    products.forEach((root) => {
      const selectedWidth = root.querySelector('[data-mmy-width][aria-pressed="true"]');
      if (selectedWidth) filterJarWidths(root, selectedWidth.dataset.mmyWidth);
      if (root.dataset.galleryInitialized) return;
      root.dataset.galleryInitialized = 'true';
      root.dataset.mmyGalleryIndex = '0';
      const stage = root.querySelector('[data-mmy-gallery-stage]');
      if (!stage) return;
      let touchStart = 0;
      stage.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (event) => {
        const distance = event.changedTouches[0].clientX - touchStart;
        if (Math.abs(distance) < 45) return;
        const current = Number(root.dataset.mmyGalleryIndex || 0);
        setGalleryImage(root, current + (distance < 0 ? 1 : -1));
      }, { passive: true });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const button = event.target.closest('[data-mmy-choice]');
    if (button) button.click();
  });
  document.addEventListener('click', (event) => {
    const menu = event.target.closest('.mmy-mobile-menu');
    if (menu && event.target.closest('nav a')) menu.removeAttribute('open');
    document.querySelectorAll('.mmy-mobile-menu[open]').forEach((item) => { if (!item.contains(event.target)) item.removeAttribute('open'); });
    const thumbnail = event.target.closest('[data-mmy-image]');
    if (thumbnail) {
      const root = thumbnail.closest('[data-mmy-product]');
      setGalleryImage(root, Number(thumbnail.dataset.mmyIndex));
    }
    const widthButton = event.target.closest('[data-mmy-width]');
    if (widthButton) filterJarWidths(widthButton.closest('[data-mmy-product]'), widthButton.dataset.mmyWidth);
    const variantChoice = event.target.closest('[data-mmy-variant-choice]');
    if (variantChoice) {
      const root = variantChoice.closest('[data-mmy-product]');
      const select = root.querySelector('[data-mmy-variant]');
      select.value = variantChoice.dataset.mmyVariantId;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      root.querySelector('[data-mmy-variant-picker]').open = false;
    }
    const galleryPrevious = event.target.closest('[data-mmy-gallery-prev]');
    const galleryNext = event.target.closest('[data-mmy-gallery-next]');
    if (galleryPrevious || galleryNext) {
      const root = event.target.closest('[data-mmy-product]');
      const current = Number(root.dataset.mmyGalleryIndex || 0);
      setGalleryImage(root, current + (galleryNext ? 1 : -1));
    }
    const thumbnailsPrevious = event.target.closest('[data-mmy-thumbs-prev]');
    const thumbnailsNext = event.target.closest('[data-mmy-thumbs-next]');
    if (thumbnailsPrevious || thumbnailsNext) {
      const root = event.target.closest('[data-mmy-product]');
      const rail = root.querySelector('[data-mmy-thumbnails]');
      rail.scrollBy({ left: rail.clientWidth * (thumbnailsNext ? 0.8 : -0.8), behavior: 'smooth' });
    }
    const quote = event.target.closest('[data-mmy-product-quote]');
    if (quote) {
      const root = quote.closest('[data-mmy-product]');
      const variant = root.querySelector('[data-mmy-variant]');
      const quantity = root.querySelector('[data-mmy-quantity]');
      if (!quantity.reportValidity()) { event.preventDefault(); return; }
      const option = variant?.selectedOptions[0]?.textContent.trim();
      const postcode = root.querySelector('[data-mmy-delivery]').value.trim();
      const message = `Hi Momoyocraft, I would like to request a quote.\n\nProduct: ${quote.dataset.productTitle}\n1. Preferred size: ${option || ''}\n2. Quantity (pcs): ${quantity.value}\n3. Location: ${postcode}\n\nThank you, our team will get back to you shortly.`;
      quote.href = quote.dataset.baseUrl + '?text=' + encodeURIComponent(message);
    }
  });
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-mmy-variant]');
    if (!select) return;
    const root = select.closest('[data-mmy-product]');
    const imageIndex = Number(select.selectedOptions[0]?.dataset.mmyImageIndex || 0);
    const selectedOption = select.selectedOptions[0];
    root.querySelector('[data-mmy-variant-label]').textContent = selectedOption?.textContent.trim() || '';
    root.querySelectorAll('[data-mmy-variant-choice]').forEach((button) => button.setAttribute('aria-selected', String(button.dataset.mmyVariantId === select.value)));
    setGalleryImage(root, imageIndex);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mmy-mobile-menu[open]').forEach((menu) => { menu.removeAttribute('open'); menu.querySelector('summary')?.focus(); });
  });
})();
